import(/* webpackMode: "eager", webpackExports: ["Game"] */ "/vercel/path0/src/app/Game.tsx");
